// import logo from '../assets/logo.webp'
// import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

const Nav = () => {

    const [showDiv, setShowDiv] = useState(false);

    const ScrollTop = () => {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    }

    useEffect(() => {
        const handleScroll = () => {
        const scrollPosition = window.scrollY;
        if (scrollPosition > window.innerHeight) {
            setShowDiv(true);
        } else {
            setShowDiv(false);
        }
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
        window.removeEventListener('scroll', handleScroll);
        };
    }, []);


    return(
        <div  className={`box ${showDiv ? 'show' : ''} flex pc justify-center items-center fixed p-3 drop-shadow-2xl bg-white top-0 z-[999] w-fit centerh px-8 rounded-b-lg`}>
            {/* <img className='h-12 mb-1 mix-blend-difference' src={logo} /> */}
            <div className="flex gap-12 uppercase text-red-900 text-xs">
                <button  onClick={ScrollTop}>HOME</button>
                <a href="#about">About</a>
                <a href="#projects">Projects</a>
                <a href="#vision">Vision</a>
                <a href="#contact">Contact</a>
            </div>
        </div>
    )
}

export default Nav;